import axios from './axios';

import { PAGE_SIZE } from '../constants/auth';
import { PaginatedResponse } from './types';
import {
  RegisteredAgentInList,
  RegisteredAgentRenewalAction,
  RegisteredAgentRenewalActionResponse,
  RegisteredAgentStatusFilter,
} from '../types/registeredAgent';

export async function getAllRegisteredAgentServices(
  pageNumber: number = 1,
  search?: string,
  status?: RegisteredAgentStatusFilter
): Promise<PaginatedResponse<RegisteredAgentInList>> {
  const params = {
    pageSize: PAGE_SIZE,
    page: pageNumber,
    company: search,
    status,
  };
  return axios.get(`/admins/products/llc/registered_agent/`, { params }).then(({ data }) => data);
}

export async function downloadReport(search: string, status: RegisteredAgentStatusFilter) {
  return await axios
    .get(`/admins/products/llc/registered_agent/report/`, {
      params: { company: search, status },
      responseType: 'blob',
    })
    .then((response) => response);
}

export async function optOutRegisteredAgent(companyId: number, companyLlcId: number) {
  return axios
    .post(`/companies/${companyId}/products/llc/company_llc/${companyLlcId}/registered_agent/opt_out/`)
    .then(({ data }) => data);
}

export async function setRegisteredAgentAdminDecision(
  companyLlcId: number,
  action: RegisteredAgentRenewalAction
) {
  return axios
    .post(`/admins/products/llc/registered_agent/${companyLlcId}/decision/`, { action })
    .then(({ data }) => data);
}

export async function submitRegisteredAgentRenewalAction(
  token: string,
  action: RegisteredAgentRenewalAction
): Promise<RegisteredAgentRenewalActionResponse> {
  return axios.post(`/products/llc/registered_agent/action/`, { token, action }).then(({ data }) => data);
}
